import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Report } from "../_types/report";
import { Observable } from "rxjs";
import * as saveAs from "file-saver";
import * as slug from "slug";


@Injectable({
    providedIn: 'root',
})

export class ReportsService extends Service<Report> {
  public override type = 'reports';
  public override url = 'reporting/reports';    

  public GetResults(reportId:string, page:number, pageSize:number, sortBy:string, sortDirection:string, filters: any): Observable<any[]> {
    let params = "";
    if(page > 0) params += "&page="+page;
    if(pageSize > 0) params += "&pageSize="+pageSize;
    if(sortBy) params += "&sortBy="+sortBy;
    if(sortDirection) params += "&sortDirection="+sortDirection;    
    let url = this.getAPIUrl()+"/"+reportId+"/results?"+params;
    return this.http.post<any[]>(url, filters);
  }  

  public getXlsx(reportId:string) {
    let url = this.getAPIUrl()+"/"+reportId+"/xlsx";
    window.open(url);
  } 

   public downloadExcel(reportId:string,fileName: string, filters: any) {
      let url = this.getAPIUrl()+"/"+reportId+"/xlsx";

      return this.http.post(url, filters, { responseType: 'blob' as 'json' }).subscribe((response: any) => {
        // Usar FileSaver.js para guardar el archivo
        saveAs(response, (fileName!=null?slug(fileName)+'.xlsx':'informe.xlsx'));
      });
    }

}
